import styled from 'styled-components';
import Button from '../../../../../components/ui/Button';

export const ErrorButton = styled(Button)`
  margin: auto;
`;
export const ModalContainer = styled('div')`
  width: min-content;
  margin: auto;
`;
